<div *ngIf="!isLoadingRegions">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-3 items-end">
    <div>
        <label for="bolha-region" i18n>Regija</label>
        <select id="bolha-region" [(ngModel)]="selectedRegion" (change)="onRegionChange($event)">
            <option value=""></option>
            <option *ngFor="let region of regions" [value]="region">{{ displayName(region) }}</option>
        </select>
    </div>

    <div [hidden]="!selectedRegion">
        <label for="bolha-city" i18n>Občina</label>
        <div *ngIf="isLoadingCities">
            <app-content-shimmer></app-content-shimmer>
        </div>
        <select *ngIf="!isLoadingCities" id="bolha-city" [(ngModel)]="selectedCity"
                (change)="onCityChange($event)"
                [ngClass]="{ 'input-error': control.hasError('incompleteLocation') && !selectedCity }"
                [disabled]="!selectedRegion">
            <option value=""></option>
            <option *ngFor="let city of cities" [value]="city">{{ displayName(city) }}</option>
        </select>
    </div>

    <div [hidden]="!selectedCity">
        <label for="bolha-place" i18n>Kraj</label>
        <div *ngIf="isLoadingPlaces">
            <app-content-shimmer></app-content-shimmer>
        </div>
        <select *ngIf="!isLoadingPlaces" id="bolha-place" [(ngModel)]="selectedPlace"
                (change)="onPlaceChange($event)"
                [ngClass]="{ 'input-error': control.hasError('incompleteLocation') && !selectedPlace }"
                [disabled]="!selectedCity">
            <option value=""></option>
            <option *ngFor="let place of places" [value]="'_' + place.bolha_id">{{ place.name }}</option>
        </select>
    </div>
    </div>

    <app-field-errors [control]="control" [hasToBeTouched]="false"></app-field-errors>
</div>
<div *ngIf="isLoadingRegions">
    <div class="mb-4">
        <app-content-shimmer></app-content-shimmer>
    </div>
    <div class="mb-4">
        <app-content-shimmer></app-content-shimmer>
    </div>
    <div class="mb-4">
        <app-content-shimmer></app-content-shimmer>
    </div>
</div>